<template>
  <div>
    <div class="modal" v-show="modalShown">
      <div class="modal-main">
        <div class="title-area">
          <h2>スタイルカラー設定</h2>
        </div>
        <div class="input-area">
          <ul>
            <li>
              <span class="label">カラースタイル名：</span>
              <span style="font-weight:bold">{{ colorStyleName }}</span>
            </li>
            <li>
              <span class="label">標準カラー：</span>
              <select v-model="defColor.colorMaterialId" v-if="defColor && Object.keys(defColor).length > 0" @change="onChangeDef">
                <option v-for=" (color,index) in colorList" :key="index" :value="color.colorMaterialId">{{ color.colorMaterialName }}</option>
              </select>
            </li>
            <!-- <li v-for="(number, i) in 10" :key="i">
              <span class="label">グループカラー{{number}}</span>
              <select v-if="defColor && Object.keys(this.defColor).length > 0" @change="onChangeDef">
                <option v-for=" (color,index) in colorList" :key="index" :value="color.colorMaterialId">{{ color.colorMaterialName }}</option>
              </select>
            </li> -->
          </ul>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onOk">OK</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
export default {
  name: 'StyleColorModal',
  props: {
    fileData: Object
  },
  data () {
    return {
      modalShown: false,
      /** 標準カラーオブジェクト */
      defColor: {
        colorMaterialId: null,
        colorMaterialName: null
      },
      /** カラースタイル名 */
      colorStyleName: null,
      /** 企業カラーリスト */
      colorList: []
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      if (this.fileData && Object.keys(this.fileData).length && this.fileData.colorStyleDataModelList && this.fileData.colorStyleDataModelList.length) {
        // カラースタイル名
        this.colorStyleName = this.fileData.colorStyleDataModelList[0].colorStyleConfigMaster.colorStyleConfigName
        // 標準カラーID
        let defId = this.fileData.colorStyleDataModelList[0].colorStyleDefault
        // 企業カラーリスト
        this.colorList = this.fileData.colorStyleDataModelList[0].colorMaterialTableMaster
        // 標準カラーオブジェクト
        let defObj = this.fileData.colorStyleDataModelList[0].colorMaterialTableMaster.find(function (m) { if (m.colorMaterialId === defId) return m })

        this.defColor.colorMaterialId = defObj.colorMaterialId
        this.defColor.colorMaterialName = defObj.colorMaterialName
        this.modalShown = true
      } else {
        AppUtil.showModal({
          messages: ['編集中のデータがありません']
        })
      }
    },
    onOk: function () {
      /** モーダル非表示 */
      this.modalShown = false
      let payload = {
        // colorStyleDataId: this.fileData.colorStyleDataModelList[0].colorStyleDataId,
        colorStyleDefault: this.defColor.colorMaterialId
        // colorStyleGroup1
        // colorStyleGroup2
        // colorStyleGroup3
        // colorStyleGroup4
        // colorStyleGroup5
        // colorStyleGroup6
        // colorStyleGroup7
        // colorStyleGroup8
        // colorStyleGroup9
        // colorStyleGroup10
      }
      axios.post(API_URL.PLANNING + '/color-style', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$emit('handleErrorMessage', response)
            AppUtil.showModal({
              messages: ['データがありません']
            })
          } else {
            AppUtil.showModal({
              messages: ['カラースタイル設定を更新しました。']
            })
            this.$emit('setResponseData', response)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage)
        })
    },
    onCancel: function () {
      this.modalShown = false
      this.colorList = []
      this.defColor = {}
    },
    onChangeDef: function (e) {
      this.defColor.colorMaterialId = e.target.value
    }
  },
  mounted: function () {
  }
}
</script>
<style scoped>
.label{
  display: inline-block;
  text-align: right;
  min-width: 135px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/StyleColorModal.vue